import { dayjs } from './dayjs';

export function shouldShowProrationModalForUpdateTerminationPendingParkers(
	previousTerminationDateInvoiceExists: boolean,
	terminationDateWasMovedBetweenMonths: boolean,
	newTerminationDateInvoiceHasBeenSent: boolean,
	everyParkerWasPreviouslyOptedOut: boolean,
): boolean {
	// the below table is meant to cover the 6 cases where we should show the original
	// proration modal when updating termination pending parkers.
	// The table contains 4 levels for the 4 criteria needed to check if we should show
	// the modal:
	// 1. if the previous termination date's invoice exists
	// 2. if the new termination date is in a different month than the previous date
	// 3. If the new termination date's auto invoice has been sent
	// 4. if every termination pending parker parker updated has previously opted out of proration
	const lookupTable = {
		true: {
			true: {
				false: {
					// case 1: show proration modal if the termination date was
					// moved to a new month, the new month's invoice has not been
					// sent yet and all parkers have previously opted out of proration.
					true: true,
				},
			},
			false: {
				true: {
					// case 2: show proration modal if the termination date was
					// updated within the same month, the invoice was already sent
					// and all parkers have previously opted out of proration.
					true: true,
				},
			},
		},
		false: {
			true: {
				false: {
					// case 3 and 4: show proration modal if the termination date was
					// moved to a new month and both the new and old termination
					// date's invoices have not been sent yet. Whether or not every
					// parker was opted out of proration does not matter in these cases.
					true: true,
					false: true,
				},
			},
			false: {
				false: {
					// case 5 and 6: show proration modal if the termination date was
					// moved within the same month and that month's termination
					// invoices have not been sent yet. Whether or not every
					// parker was opted out of proration does not matter in these cases.
					true: true,
					false: true,
				},
			},
		},
	};
	try {
		// Try to lookup the case directly. If the case isn't found,
		// a TypeError will be thrown. If so we catch the error and
		// just return false. We have to cast the boolean parameters
		// to string as TypeScript doesn't like us using a boolean
		// as an index type.
		return lookupTable[String(previousTerminationDateInvoiceExists)][String(terminationDateWasMovedBetweenMonths)][
			String(newTerminationDateInvoiceHasBeenSent)
		][String(everyParkerWasPreviouslyOptedOut)];
	} catch {
		return false;
	}
}

export function isStartDateInPreviousParkingPeriod(parkers, selectedParkerIds): boolean {
	const filterSelectParkers =
		parkers.filter((parker) => selectedParkerIds.find((parkerId) => parkerId === parker.id)) || [];

	const findPastStartDates = filterSelectParkers.find((parker) => {
		const parkerDateStart = parker.parkerStartDate || parker.parker_start_date;
		const parkerStartDate = dayjs(parkerDateStart, 'YYYY-MM-DD');
		const startOfCurrentMonth = dayjs().startOf('month');
		return parkerStartDate.isBefore(startOfCurrentMonth);
	});

	return !!findPastStartDates;
}
